import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "xlsx";
import { toLakhs, getBrandOptions } from "../../utils/constants";
import { format } from "date-fns";
function DailyVsEenadu() {
  const [data, setData] = useState([]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/dailymissing",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: selectedMonth,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const headers = [
        [
         "Date",
         "Client",
         "Sales Person",
         "Missing Status",
         "Last Met"
        ],
        
      ];

      const rows = [
        ...(data?.data?.map((item)=> ([format(item.date*1000,'dd/MM/yyyy'),item.brand_name, item.name, item.knownCampaign ? 'Known' : 'Unknown', daysAgo(item.last_interaction)])))
          
      ];

      const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Missing");
      XLSX.writeFile(workbook, `dailyMissing.xlsx`);
    } catch (error) {
      console.error(error, "Daily Missing");
    } finally {
      setDownloadLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
  };

  function daysAgo(timestamp) {
    if (timestamp === null || timestamp === undefined) {
        return 'N/A';
    }
    const now = Math.floor( new Date(selectedMonth).getTime() / 1000); // Current time in seconds
    const diffInSeconds = now - timestamp;
    const diffInDays = Math.floor(diffInSeconds / (60 * 60 * 24)); // Convert seconds to days

    if (diffInDays < 30) {
        return `${diffInDays} day${diffInDays === 1 ? '' : 's'} ago`;
    } else {
        const diffInMonths = Math.floor(diffInDays / 30);
        return `${diffInMonths} month${diffInMonths === 1 ? '' : 's'} ago`;
    }
}

  useEffect(()=>{
    fetchData()
  },[selectedMonth,selectedNewspaper, selectedType])
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Daily Missing</h5>
        <aside className="flex gap-3 items-center">
          <SlSelect
            size="small"
            value={selectedType}
            label="Team"
            onSlChange={(e) => {
              setSelectedType(e.target.value);
            }}
          >
            {data?.userType === -1 ? (
              <SlOption value="all">All</SlOption>
            ) : null}
            {getBrandOptions(
              data?.userType,
              localStorage.getItem("email")
            )?.map((type) => (
              <SlOption key={type.value} value={type.value}>
                {type.label}
              </SlOption>
            ))}
          </SlSelect>
          <SlSelect
            label="Newspaper"
            size="small"
            value={selectedNewspaper}
            onSlChange={(e) => setSelectedNewspaper(e.target.value)}
          >
            {newspapers.map((paper) => (
              <SlOption value={paper.name}>{paper.name}</SlOption>
            ))}
          </SlSelect>
          <div className="clientwiserevenue-datepicker max-w-[200px] ">
            <label className="form-label">Select Date</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              className="dateChooser border h-5 rounded-md"
            />
          </div>
          {downloadLoader ? (
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <div
              className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
              onClick={getdownloadData}
            >
              <sl-tooltip content="Download" placement="top">
                <SlIcon library="lucide" name="download" />
              </sl-tooltip>
            </div>
          )}
        </aside>
      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th>Date</th>
              <th>Client</th>
              <th>Sales Person</th>
              <th>Missing Status</th>
              <th>Last Met</th>
            </tr>
          </thead>
          {
            (!loader && data?.data?.length > 0) ?
            <tbody>
              {data?.data?.map((missing, index)=>(
                <tr key={missing.brand_id}>
                  <td>{format(missing.date*1000, 'dd/MM/yyyy')}</td>
                  <td>{missing.brand_name}</td>
                  <td>{missing.name}</td>
                  <td>{missing.knowncampaign ? 'Known' : 'Unknown'}</td>
                  <td>{daysAgo(missing.last_interaction)}</td>
                </tr>
              ))}
            </tbody> : 
            loader ? <TableSkelton rowSpan={15} colspan={5}/> : <NoDataFound  colspan={5}/>
          }
        </table>
      </ScrollContainer>
    </>
  );
}

export default DailyVsEenadu;
